import { sanitizePdfFilename } from "@/src/lib/pdf/filename";

export function saveBlobAsDownload(blob: Blob, filename: string) {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = objectUrl;
  link.download = sanitizePdfFilename(filename);
  document.body.append(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}
